import { toast } from "sonner";
import { Eye, LogOut } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const ImpersonationBanner = () => {
  const { user } = useAuth();
  if (!user || !user.impersonating) return null;

  const exit = async () => {
    try {
      await api.post("/auth/stop-impersonation");
      window.location.assign("/super/businesses");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="sticky top-0 z-[60] flex items-center justify-between gap-3 bg-amber-500 px-4 py-2 text-sm font-bold text-slate-950 shadow-md" data-testid="impersonation-banner">
      <span className="flex items-center gap-2 truncate">
        <Eye className="h-4 w-4 shrink-0" /> IMPERSONATING: {user.business?.name} ({user.email})
      </span>
      <button onClick={exit} className="flex shrink-0 items-center gap-1 rounded-md bg-slate-950 px-3 py-1 text-xs text-white transition-colors hover:bg-slate-800" data-testid="exit-impersonation-btn">
        <LogOut className="h-3.5 w-3.5" /> Exit
      </button>
    </div>
  );
};
